import { make } from "vuex-pathify"

import * as defaults from "./defaults"

const state = () => {
  return {
    audiencesTemplates: defaults.TEMPLATES,
    audiencesTemplatesTypes: defaults.TEMPLATES_TYPES,

    loading: false,
  }
}

const actions = {}

const getters = {
  ...make.getters(state),
  findAudienceTemplateTypeByTemperature: state => temperature => {
    return state.audiencesTemplatesTypes.find(
      i => i.temperature === temperature
    )
  },
}

const mutations = {
  ...make.mutations(state),
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
